'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlRequest = require('graphql-request');
var groupBy = require('lodash/groupBy');
var react = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var groupBy__default = /*#__PURE__*/_interopDefaultLegacy(groupBy);

var Stage = /* @__PURE__ */ ((Stage2) => {
  Stage2["dev"] = "dev";
  Stage2["prod"] = "prod";
  return Stage2;
})(Stage || {});

const Config = {
  dev: {
    host: "api-dev.3fourteenresearch.com",
    apiUrl: "https://api-dev.3fourteenresearch.com",
    wpApiUrl: "https://staging.three14research.com/graphql"
  },
  prod: {
    host: "api.3fourteenresearch.com",
    apiUrl: "https://api.3fourteenresearch.com",
    wpApiUrl: "https://3fourteenresearch.com/graphql"
  }
};
exports.__stage = Stage.prod;
function setStage(stage) {
  exports.__stage = stage;
}
function getStage() {
  return exports.__stage;
}

var __async$a = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let tokenInMemory;
function graphRequest(document2, variables) {
  return __async$a(this, null, function* () {
    var _a, _b, _c;
    const stage = getStage();
    const client = new graphqlRequest.GraphQLClient(`${Config[stage].wpApiUrl}`, {
      headers: {
        authorization: !!tokenInMemory ? `Bearer ${tokenInMemory}` : void 0
      }
    });
    try {
      const response = yield client.request(document2, variables);
      return response;
    } catch (e) {
      const errors = (_a = e == null ? void 0 : e.response) == null ? void 0 : _a.errors;
      const invalidJwt = (_c = (_b = errors[0]) == null ? void 0 : _b.debugMessage) == null ? void 0 : _c.includes("invalid-jwt");
      if (invalidJwt) {
        console.log("refreshing");
        yield refreshToken();
      } else {
        throw e;
      }
    }
  });
}
var LoginErrorResponse = /* @__PURE__ */ ((LoginErrorResponse2) => {
  LoginErrorResponse2["incorrectPassword"] = "incorrect_password";
  LoginErrorResponse2["emptyUsername"] = "empty_username";
  LoginErrorResponse2["emptyPassword"] = "empty_password";
  LoginErrorResponse2["invalidEmail"] = "invalid_email";
  LoginErrorResponse2["invalidUsername"] = "invalid_username";
  LoginErrorResponse2["inactive"] = "inactive_user";
  return LoginErrorResponse2;
})(LoginErrorResponse || {});
const loginErrorMap = {
  incorrect_password: "Incorrect email or password",
  empty_username: "Please provide an email address",
  empty_password: "Please enter a password",
  invalid_email: "Incorrect email or password",
  invalid_username: "Incorrect email or password",
  inactive_user: "Service for this account has expired"
};
const login = (params) => __async$a(void 0, null, function* () {
  const stage = getStage();
  try {
    const response = yield fetch(`${Config[stage].apiUrl}/auth/login`, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(params),
      credentials: "include"
    });
    const { error, data } = yield response.json();
    if (!!error) {
      throw error;
    }
    tokenInMemory = data.authToken;
    return data;
  } catch (e) {
    const errorMessage = loginErrorMap[e.message] || "An unknown error occurred";
    throw new Error(errorMessage);
  }
});
const logout = () => __async$a(void 0, null, function* () {
  const stage = getStage();
  try {
    yield fetch(`${Config[stage].apiUrl}/auth/logout`, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      credentials: "include"
    });
  } catch (e) {
    const errorMessage = loginErrorMap[e.message] || "An unknown error occurred";
    throw new Error(errorMessage);
  }
});
const refreshToken = () => __async$a(void 0, null, function* () {
  const stage = getStage();
  try {
    const response = yield fetch(`${Config[stage].apiUrl}/auth/refresh-token`, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json"
      },
      credentials: "include"
    });
    const res = yield response.json();
    const { data, error } = res;
    if (!!error) {
      throw new Error(error.message);
    }
    tokenInMemory = data.authToken;
    return data;
  } catch (e) {
    throw e;
  }
});
const getAuthToken = () => {
  if (typeof window !== "undefined" && (window == null ? void 0 : window.Cypress)) {
    const cookie = ("; " + document.cookie).split(`; token=`).pop().split(";")[0];
    return cookie;
  }
  return tokenInMemory;
};
const deleteAuthToken = () => {
  tokenInMemory = null;
};

const assetNameMap = {
  ["Alternatives"]: "Alternatives",
  ["Fixed Income"]: "Fixed Income",
  ["Cash"]: "Cash",
  ["Bonds"]: "Bonds",
  ["Equities"]: "Equities",
  ["Real Assets"]: "Real Assets",
  ["Corporate Bonds"]: "Corp Bonds",
  ["Corp Bonds"]: "Corp Bonds",
  ["Emerging Markets Bonds"]: "Em Mkts Bonds",
  ["Emerging Mkt Bonds"]: "Em Mkts Bonds",
  ["High Yield"]: "High Yield",
  ["Long Term Treasuries"]: "LT Treasuries",
  ["LT Treasuries"]: "LT Treasuries",
  ["TIPS"]: "TIPS",
  ["EAFE"]: "EAFE",
  ["Emerging Markets"]: "Em Mkts",
  ["US Large Cap"]: "US Lg Cap",
  ["Large Cap"]: "Lg Cap",
  ["Nasdaq"]: "Nasdaq",
  ["US Small Cap"]: "US Sm Cap",
  ["Small Cap"]: "Sm Cap",
  ["Value"]: "Value",
  ["Bitcoin"]: "Bitcoin",
  ["Commodities"]: "Commodities",
  ["Gold"]: "Gold",
  ["Real Estate"]: "Real Estate",
  ["Volatility"]: "Volatility",
  ["Energy"]: "Energy",
  ["Utilities"]: "Utilities",
  ["Tobacco"]: "Tobacco",
  ["Munis"]: "Munis",
  ["Aristocrats"]: "Aristocrats",
  ["REITs"]: "REITs",
  ["EM Bonds"]: "EM Bonds",
  ["TIPs"]: "TIPs",
  ["IG Corporates"]: "IG Corporates",
  ["Treasurys"]: "Treasurys",
  ["Preferreds"]: "Preferreds",
  ["Dividend Payers"]: "Dividend Payers",
  ["T-Bills"]: "T-Bills",
  ["Japan"]: "Japan",
  ["Europe"]: "Europe",
  ["Miners"]: "Miners",
  ["Managed Futures"]: "Managed Futures",
  ["Emerging Ex. China"]: "Em Ex. China"
};

const chartTagFilters = [
  {
    id: "bitcoin",
    label: "Bitcoin"
  },
  {
    id: "crude",
    label: "Crude"
  },
  {
    id: "currencies",
    label: "Currencies"
  },
  {
    id: "gold",
    label: "Gold"
  },
  {
    id: "macro",
    label: "Macro"
  },
  {
    id: "market-bottom",
    label: "Market Bottom"
  },
  {
    id: "real-asset-allocation",
    label: "Real Asset Allocation"
  },
  {
    id: "sp-500",
    label: "S&P 500"
  },
  {
    id: "technicals",
    label: "Technicals"
  },
  {
    id: "trading-strategy",
    label: "Trading Strategy"
  },
  {
    id: "trend-breadth",
    label: "Trend Breadth"
  }
];
const chartsSortOptions = [
  {
    field: "DATE",
    order: "DESC",
    label: "Recently Added"
  },
  {
    field: "DATE",
    order: "ASC",
    label: "Oldest"
  },
  {
    field: "TITLE",
    order: "ASC",
    label: "A-Z"
  },
  {
    field: "TITLE",
    order: "DESC",
    label: "Z-A"
  }
];

const PUBLIC_CLOUDFRONT_DOMAIN = "https://d2mnkrcyowo3a8.cloudfront.net";

const publicationsCategoryId = 14;
const chartBooksCategoryId = 21;
const modelUpdatesCategoryId = 19;
const positionUpdatesCategoryId = 72;
const retrospectiveCategoryId = 78;
const chartsCategoryId = 18;
const modelsCategoryId = 17;
const categorizedPostIds = [
  publicationsCategoryId,
  chartBooksCategoryId,
  modelUpdatesCategoryId,
  positionUpdatesCategoryId,
  retrospectiveCategoryId,
  chartsCategoryId,
  modelsCategoryId
];
const commentaryCategoryIds = [
  publicationsCategoryId,
  chartBooksCategoryId,
  modelUpdatesCategoryId,
  positionUpdatesCategoryId,
  retrospectiveCategoryId
];
const filterCommentary = (commentary, categoryIds) => commentary.filter((comm) => categoryIds.find((id) => id === comm.categoryId));
const goldModelId = "cG9zdDo0MDg0";
const crudeModelId = "cG9zdDoyOTI1";
const realAssetAllocationModelId = "cG9zdDoyNTYw";
const yoModelId = "cG9zdDo0MTMx";
const fernandoVidal = 11;
const warrenPies = 1;
const authorMap = {
  1: {
    twitter: "WarrenPies",
    title: "Founder",
    credentials: "ERP"
  },
  11: {
    twitter: "fernavid",
    title: "Co-Founder & Chief Data Scientist",
    credentials: ""
  }
};
const categorySlugMap = {
  publications: "Publications",
  "model-updates": "Model Updates",
  "position-updates": "Position Updates",
  "chart-books": "Chart Books",
  retrospectives: "Retrospectives",
  charts: "Charts",
  models: "Models",
  custom: "Custom"
};

const commentaryTypeFilters = [
  {
    id: "publications",
    categoryId: 14,
    label: "Publications",
    categorySlug: "publications"
  },
  {
    id: "model-updates",
    categoryId: 19,
    label: "Model Updates",
    categorySlug: "model-updates"
  },
  {
    id: "chart-books",
    categoryId: 21,
    label: "Chart Books",
    categorySlug: "chart-books"
  },
  {
    id: "position-updates",
    categoryId: 72,
    label: "Position Updates",
    categorySlug: "position-updates"
  },
  {
    id: "retrospectives",
    categoryId: 78,
    label: "Retrospectives",
    categorySlug: "retrospectives"
  }
];
const commentaryYearFilters = [2025, 2024, 2023, 2022, 2021, 2020];
const commentaryAuthorFilters = [
  {
    authorId: warrenPies,
    label: "Warren Pies"
  },
  {
    authorId: fernandoVidal,
    label: "Fernando Vidal"
  }
];
const commentarySortOptions = [
  {
    field: "DATE",
    order: "DESC",
    label: "Most Recent"
  },
  {
    field: "DATE",
    order: "ASC",
    label: "Oldest"
  },
  {
    field: "TITLE",
    order: "ASC",
    label: "A-Z"
  },
  {
    field: "TITLE",
    order: "DESC",
    label: "Z-A"
  }
];

var CoreModelSignal = /* @__PURE__ */ ((CoreModelSignal2) => {
  CoreModelSignal2["strongSell"] = "strong sell";
  CoreModelSignal2["sell"] = "sell";
  CoreModelSignal2["neutral"] = "neutral";
  CoreModelSignal2["buy"] = "buy";
  CoreModelSignal2["strongBuy"] = "strong buy";
  CoreModelSignal2["oneHundredLong"] = "100% Long";
  CoreModelSignal2["fiftyLong"] = "50% Long";
  CoreModelSignal2["cash"] = "Cash";
  return CoreModelSignal2;
})(CoreModelSignal || {});

var CoreModelCode = /* @__PURE__ */ ((CoreModelCode2) => {
  CoreModelCode2["crude"] = "crude";
  CoreModelCode2["gold"] = "gold";
  CoreModelCode2["bitcoin"] = "bitcoin";
  CoreModelCode2["spRisk"] = "spRisk";
  return CoreModelCode2;
})(CoreModelCode || {});
var AllocationModelCode = /* @__PURE__ */ ((AllocationModelCode2) => {
  AllocationModelCode2["raa"] = "raa";
  AllocationModelCode2["RAA_V2_20"] = "RAA_V2_20";
  AllocationModelCode2["RAA_V2_10"] = "RAA_V2_10";
  AllocationModelCode2["yo"] = "yo";
  AllocationModelCode2["sector"] = "sector";
  return AllocationModelCode2;
})(AllocationModelCode || {});
var StockSelectionModelCode = /* @__PURE__ */ ((StockSelectionModelCode2) => {
  StockSelectionModelCode2["fullCycle"] = "fullCycle";
  StockSelectionModelCode2["fctm"] = "fctm";
  StockSelectionModelCode2["trendRisk"] = "trendRisk";
  StockSelectionModelCode2["picks"] = "picks";
  return StockSelectionModelCode2;
})(StockSelectionModelCode || {});

var ReadingsFilename = /* @__PURE__ */ ((ReadingsFilename2) => {
  ReadingsFilename2["raa"] = "aa.json";
  ReadingsFilename2["RAA_V2_20"] = "RAA_V2_20.json";
  ReadingsFilename2["RAA_V2_10"] = "RAA_V2_10.json";
  ReadingsFilename2["RAA_V2_20_dev"] = "RAA_V2_20_dev.json";
  ReadingsFilename2["bitcoin"] = "bitcoin_model.json";
  ReadingsFilename2["crude"] = "crude.json";
  ReadingsFilename2["gold"] = "gold.json";
  ReadingsFilename2["fullCycle"] = "trend_quality.json";
  ReadingsFilename2["fullCycleDev"] = "trend_quality_dev.json";
  ReadingsFilename2["fctm"] = "fctm.json";
  ReadingsFilename2["picks"] = "positions.json";
  ReadingsFilename2["sector"] = "sector.json";
  ReadingsFilename2["spRisk"] = "sp_risk_model.json";
  ReadingsFilename2["stratAA"] = "strat_aa.json";
  ReadingsFilename2["trendRisk"] = "stock_selection_tbrisk.json";
  ReadingsFilename2["yo"] = "yield_aa.json";
  ReadingsFilename2["latestCommentary"] = "latest-commentary.json";
  return ReadingsFilename2;
})(ReadingsFilename || {});
var WeightColor = /* @__PURE__ */ ((WeightColor2) => {
  WeightColor2["red"] = "#a64a42";
  WeightColor2["yellow"] = "#fcbb40";
  WeightColor2["green"] = "#6a8d73";
  return WeightColor2;
})(WeightColor || {});

const coreModelSignalMap = {
  crude: {
    [-1]: CoreModelSignal.strongSell,
    [-0.5]: CoreModelSignal.sell,
    [0]: CoreModelSignal.neutral,
    [0.5]: CoreModelSignal.buy,
    [1]: CoreModelSignal.strongBuy
  },
  gold: {
    [-1]: CoreModelSignal.strongSell,
    [-0.5]: CoreModelSignal.sell,
    [0]: CoreModelSignal.neutral,
    [0.5]: CoreModelSignal.buy,
    [1]: CoreModelSignal.strongBuy
  },
  bitcoin: {
    [0]: CoreModelSignal.cash,
    [0.5]: CoreModelSignal.fiftyLong,
    [1]: CoreModelSignal.oneHundredLong
  }
};
const coreModelComponentMap = {
  technicals: "Technicals",
  physical_mkt: "Physical Market",
  positioning: "Positioning",
  inventories: "Inventories",
  overall: "Core Model",
  realrates: "Real Rates",
  hrp: "Asset Allocation",
  macro: "Macro",
  valuation: "Valuation",
  volatility: "Volatility",
  price: "Price",
  volume: "Flow"
};
const coreModelColorMap = {
  [-1]: WeightColor.red,
  [-0.5]: WeightColor.red,
  [0]: WeightColor.yellow,
  [0.5]: WeightColor.green,
  [1]: WeightColor.green
};

const formatMarketCap = (marketCap) => {
  if (!isNaN(parseFloat(marketCap)) && isFinite(marketCap)) {
    const formatted = (marketCap / 1e9).toFixed(2);
    return `$${formatted}B`;
  } else {
    return "";
  }
};
const formatPercent = (number, decimalPlaces) => {
  const decimals = decimalPlaces === 0 || !!decimalPlaces ? decimalPlaces : 1;
  if (!isNaN(parseFloat(number)) && isFinite(number)) {
    const formatted = (number * 100).toFixed(decimals);
    return `${formatted}%`;
  }
  return void 0;
};

const PORTFOLIO_BUILDER_MONTHLY_MEMBERSHIP_ID = 5732;
const PORTFOLIO_BUILDER_ANNUAL_MEMBERSHIP_ID = 5869;
const ANNUAL_MEMBERSHIP_ID = 3265;
const SEMIANNUAL_MEMBERSHIP_ID = 4912;
const QUARTERLY_MEMBERSHIP_ID = 2656;
const TRIAL_MEMBERSHIP_ID = 3412;

const introductoryPaperLinks = {
  spRisk: "/publications/facing-fears-measuring-risk",
  raa: "/publications/real-asset-allocation-adapt-to-thrive",
  RAA_V2_20: "/publications/real-asset-allocation-the-world-has-changed",
  RAA_V2_10: "/publications/real-asset-allocation-the-world-has-changed",
  sector: "/publications/h2-outlook-whistling-past-the-graveyard",
  crude: "/publications/introducing-our-core-crude-oil-model",
  gold: "/publications/gold-modeling-systemic-trust",
  bitcoin: "/publications/bitcoin-crypto-fraud-or-the-future",
  yo: "/publications/the-great-yield-famine",
  fullCycle: "/publications/stock-selection-for-a-new-market-regime",
  fctm: "/publications/regime-change",
  trendRisk: "/publications/saving-us-from-ourselves-stock-selection-v1-0"
};

const raaVersions = [
  {
    id: AllocationModelCode.RAA_V2_20,
    displayName: "Core",
    description: "Current 20-asset RAA Model",
    whitepaper: introductoryPaperLinks.RAA_V2_20
  },
  {
    id: AllocationModelCode.RAA_V2_10,
    displayName: "Simple",
    description: "Current 10-asset RAA Model",
    whitepaper: introductoryPaperLinks.RAA_V2_10
  },
  {
    id: AllocationModelCode.raa,
    displayName: "v1",
    description: "First version of RAA Model",
    whitepaper: introductoryPaperLinks.raa
  }
];

const white = "#ffffff";
const extraExtraLightGray = "#F8F8F8";
const extraLightGray = "#f0f0f0";
const lightGray = "#dddddd";
const middleGray = "#cccccc";
const darkGray = "#666666";
const extraDarkGray = "#333333";
const green = "#8AD821";
const red = "#F42619";
const cyan = "#00BBFF";
const lightLavender = "#EBEFF6";
const middleViolet = "#658DC7";
const darkViolet = "#3461A2";
const orange = "#ef6d02";
const purple = "#D200FF";
const facebookBlue = "#4267B2";
const socialBlue = "#4589CE";
const almostWhite = "#fafafa";
const darkTeal = "#254653";
const lightestTeal = "#e6f0f4";
const darkerTeal = "#192f38";
const tealBlack = "#373e41";
const muteGray = "#6d6e71";
const muteOrange = "#bf5b20";
const muteTurqoise = "#006e96";
const muteGreen = "#8c8700";
const muteYellow = "#d99b00";
const defaultGray = "rgb(242, 242, 242)";
const twitter = "#1DA1F2";
const linkedin = "#2867B2";
const navy = "#455899";
const plum = "#994558";
const puke = "#829945";
const burntOrange = "#e9883e";
const royalPurple = "#43266b";
const muteNavy = navy;
const dandelion = "#e9b33e";
const darkSienna = "#53131E";
const terraCotta = "#E26D5C";
const catwaba = "#723D46";
const copperRed = "#D1603D";
const vermillion = "#C73E1D";
const midRed = "#A64A42";
const darkRed = "#723D46";
const tangerine = "#EF8A17";
const tuscanRed = "#7D4F50";
const orangeSoda = "#FE5E41";
const carrot = "#F18F01";
const rusticOrange = "#bc5d2e";
const mustard = "#F5D547";
const goldenRod = "#D19C1D";
const arylide = "#E3D26F";
const macMinimize = "#fcbb40";
const googleYellow = "#F2BD42";
const shamrock = "#62A87C";
const mossGreen = "#8B9556";
const mint = "#ABEBD2";
const cadetBlue = "#51A3A3";
const cambridgeBlue = "#9DCBBA";
const queenBlue = "#33488a";
const darkPurple = "#320A28";
const eggplant = "#734b72";
const camel = "#B49A67";
const weightRed = "#a64a42";
const weightGreen = "#6A8D73";
const weightYellow = "#fcbb40";
const purple0 = "#DDA3B2";
const purple1 = "#6c4967";
const blue1 = "#13607a";
const green3 = "#31827b";
const yellow3 = "#f4b64d";
const orange4 = "#b05a39";
const brown2 = "#544235";
const green2 = shamrock;
const gray = muteGray;
const chartColors = [
  navy,
  carrot,
  shamrock,
  orange4,
  brown2,
  macMinimize,
  darkSienna,
  green2,
  purple0,
  terraCotta,
  green3,
  yellow3,
  blue1,
  gray,
  purple1
];
const publicationColor = queenBlue;
const modelUpdateColor = plum;
const chartBookColor = mossGreen;
const chartColor = cadetBlue;
const modelColor = "#a351a3";
const positionUpdateColor = rusticOrange;
const retroColor = "#fcab40";

var __defProp$2 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
const formatWeight = (number, decimalPlaces) => {
  const formatted = formatPercent(number, decimalPlaces);
  if (!!formatted) {
    return formatted;
  } else {
    return "Updating...";
  }
};
const getWeightChange = (current, previous) => {
  const weightChange = current - previous;
  if (!(!isNaN(parseFloat(weightChange)) && isFinite(weightChange))) {
    return {
      backgroundColor: "transparent",
      color: tealBlack,
      weightChange: "N/A",
      icon: ""
    };
  }
  const formatted = `${(weightChange * 100).toFixed(2)}%`;
  if (current > previous) {
    return {
      backgroundColor: WeightColor.green,
      color: "white",
      weightChange: `+${formatted}`,
      icon: "caretup"
    };
  } else if (current < previous) {
    return {
      backgroundColor: WeightColor.red,
      color: "white",
      weightChange: formatted,
      icon: "caretdown"
    };
  } else {
    return {
      backgroundColor: WeightColor.yellow,
      color: tealBlack,
      weightChange: formatted,
      icon: ""
    };
  }
};
function sortAssets(assets) {
  const assetsWithSortedChildren = assets.map((asset) => {
    const sorted = asset.children.sort((a, b) => a.name > b.name ? 1 : -1);
    return __spreadProps$1(__spreadValues$2({}, asset), {
      children: sorted
    });
  });
  return assetsWithSortedChildren.sort((a, b) => a.name > b.name ? 1 : -1);
}
const flattenYoReadings = (data) => {
  const { assets: readings, colHeaders } = data;
  const cash = readings.find(({ name }) => name === "Cash");
  const stocks = readings.find(({ name }) => name === "Stock");
  const yoReadings = [
    {
      name: cash.name,
      ticker: "Cash",
      weight: cash.weight
    },
    ...stocks.children
  ];
  const sortedStocks = [...yoReadings].sort(
    (a, b) => a.weight[0] < b.weight[0] ? 1 : -1
  );
  return {
    assets: sortedStocks,
    dates: colHeaders
  };
};
const readingsFilenameMap = {
  raa: ReadingsFilename.raa,
  RAA_V2_20: ReadingsFilename.RAA_V2_20,
  RAA_V2_10: ReadingsFilename.RAA_V2_10,
  bitcoin: ReadingsFilename.bitcoin,
  crude: ReadingsFilename.crude,
  gold: ReadingsFilename.gold,
  fullCycle: ReadingsFilename.fullCycle,
  fctm: ReadingsFilename.fctm,
  picks: ReadingsFilename.picks,
  sector: ReadingsFilename.sector,
  spRisk: ReadingsFilename.spRisk,
  trendRisk: ReadingsFilename.trendRisk,
  yo: ReadingsFilename.yo
};

function getCurrentDrawdownRisk(currentValue) {
  const rounded = Math.round(currentValue * 1e3) / 1e3;
  if (rounded > 0 && rounded < 0.15) {
    return {
      label: "low risk",
      color: weightGreen
    };
  } else if (rounded >= 0.15 && rounded < 0.2) {
    return {
      label: "moderate risk",
      color: weightYellow
    };
  } else if (rounded >= 0.2) {
    return {
      label: "high risk",
      color: weightRed
    };
  }
}

const sectorDisplayNameMap = {
  ["Information Technology"]: "Tech",
  ["Consumer Discretionary"]: "Discretionary",
  ["Communication Services"]: "Communication",
  ["Consumer Staples"]: "Staples"
};

var RecommendationWeight = /* @__PURE__ */ ((RecommendationWeight2) => {
  RecommendationWeight2["underweight"] = "underweight";
  RecommendationWeight2["benchmark"] = "benchmark";
  RecommendationWeight2["overweight"] = "overweight";
  return RecommendationWeight2;
})(RecommendationWeight || {});
function getRecReading(rec, benchmark) {
  if (rec == benchmark) {
    return "benchmark" /* benchmark */;
  } else if (rec > benchmark) {
    return "overweight" /* overweight */;
  } else {
    return "underweight" /* underweight */;
  }
}
const recommendationMap = {
  underweight: {
    color: weightRed,
    label: "UW"
  },
  benchmark: {
    color: weightYellow,
    label: "BMW"
  },
  overweight: {
    color: weightGreen,
    label: "OW"
  }
};

function getRiskColor(reading) {
  const text = reading.toLowerCase();
  if (text.includes("low")) {
    return weightGreen;
  } else if (text.includes("high")) {
    return weightRed;
  } else {
    return weightYellow;
  }
}
function getGroupedSectors(data) {
  const grouped = groupBy__default["default"](data, "sector");
  const sectors = Object.keys(grouped).map((sector) => ({
    sector,
    length: grouped[sector].length
  }));
  return [...sectors].sort((a, b) => a.length < b.length ? 1 : -1);
}
function getIndustryCellColor(reading) {
  if (reading > 0.9) {
    return "green";
  } else {
    return void 0;
  }
}
function getSectorCellColor(reading) {
  if (reading > 0.7) {
    return "green";
  } else if (reading < 0.3) {
    return "red";
  } else {
    return void 0;
  }
}
function getImplicitCashPosition(currentValue) {
  return currentValue > 0.2 ? formatWeight(currentValue) : "0%";
}

const tagLabelMap = {
  bitcoin: "Bitcoin",
  crude: "Crude",
  currencies: "Currencies",
  gold: "Gold",
  "market-bottom": "Market Bottom",
  macro: "Macro",
  "real-asset-allocation": "Real Asset Allocation",
  "sp-500": "S&P 500",
  technicals: "Technicals",
  "trading-strategy": "Trading Strategy",
  "trend-breadth": "Trend Breadth"
};

var __async$9 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function fetchFavorites() {
  return __async$9(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/favorites`, {
        method: "get",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        }
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          return yield new Response(body, {}).json();
        } else {
          return yield response.json();
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function updateFavorites(favorites) {
  return __async$9(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/favorites`, {
        method: "put",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        },
        body: JSON.stringify({ data: { favorites } })
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return res.data;
        } else {
          const res = yield response.json();
          return res.data;
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function toggleFavorite(favorite) {
  return __async$9(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/favorites`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        },
        body: JSON.stringify({ data: { favorite } })
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return res.data;
        } else {
          const res = yield response.json();
          return res.data;
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __async$8 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function fetchReadings(params) {
  return __async$8(this, null, function* () {
    const apiParams = __spreadValues$1({}, params);
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/readings`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        },
        body: JSON.stringify(apiParams)
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return JSON.parse(res.data);
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function fetchPerformance(model) {
  return __async$8(this, null, function* () {
    const jsonUrl = readingsFilenameMap[model];
    const performanceUrl = `performance/${jsonUrl}`;
    const apiParams = {
      jsonUrl: performanceUrl,
      authToken: getAuthToken()
    };
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/readings`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(apiParams)
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return JSON.parse(res.data);
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}

var __async$7 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchRaaReadings = (raaFilename) => __async$7(void 0, null, function* () {
  var _a;
  try {
    const isDev = ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname) === "dev.3fourteenresearch.com";
    const jsonUrl = isDev ? ReadingsFilename.RAA_V2_20_dev : raaFilename;
    const data = yield fetchReadings({
      jsonUrl
    });
    const { assets, colHeaders } = data;
    const sortedAssets = sortAssets(assets);
    return { readings: sortedAssets, dates: colHeaders };
  } catch (error) {
    throw error;
  }
});
const fetchCrudeReadings = () => __async$7(void 0, null, function* () {
  try {
    const data = yield fetchReadings({
      jsonUrl: ReadingsFilename.crude
    });
    const readings = Object.keys(data.readings).reverse().map((key) => {
      return {
        component: key,
        signal: data.readings[key].current_signal,
        value: data.readings[key].signal_value
      };
    });
    return {
      readings,
      date: data.date
    };
  } catch (error) {
    console.log("error fetching crude readings :>> ", error);
    throw error;
  }
});
const fetchGoldReadings = () => __async$7(void 0, null, function* () {
  try {
    const data = yield fetchReadings({
      jsonUrl: ReadingsFilename.gold
    });
    const date = Object.keys(data)[0];
    const goldReadings = data[date];
    const readings = Object.keys(goldReadings).reverse().map((key) => {
      return {
        component: key,
        signal: goldReadings[key]
      };
    });
    return {
      readings,
      date
    };
  } catch (error) {
    console.log("error fetching gold readings :>> ", error);
    throw error;
  }
});
const fetchYoReadings = () => __async$7(void 0, null, function* () {
  try {
    const data = yield fetchReadings({
      jsonUrl: ReadingsFilename.yo
    });
    const { assets } = flattenYoReadings(data);
    const { colHeaders: dates } = data;
    return {
      readings: assets,
      dates
    };
  } catch (error) {
    console.log("error fetching YO readings :>> ", error);
    throw error;
  }
});
const fetchDrawdownReadings = () => __async$7(void 0, null, function* () {
  try {
    const response = yield fetchReadings({
      jsonUrl: ReadingsFilename.spRisk
    });
    const { data, as_of, current_value } = response;
    return {
      date: as_of,
      currentValue: current_value,
      components: data
    };
  } catch (error) {
    throw error;
  }
});
const fetchBitcoinReadings = () => __async$7(void 0, null, function* () {
  try {
    const response = yield fetchReadings({
      jsonUrl: ReadingsFilename.bitcoin
    });
    const { date, data } = response;
    return {
      date,
      readings: data
    };
  } catch (error) {
    throw error;
  }
});
const fetchSectorRotation = () => __async$7(void 0, null, function* () {
  try {
    const response = yield fetchReadings({
      jsonUrl: ReadingsFilename.sector
    });
    return response;
  } catch (error) {
    throw error;
  }
});
const fetchLatestCommentary = () => __async$7(void 0, null, function* () {
  const response = yield fetchReadings({
    jsonUrl: ReadingsFilename.latestCommentary
  });
  return response;
});

var __async$6 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function deletePortfolio(id) {
  return __async$6(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/portfolios/${id}`, {
        method: "delete",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        }
      });
      if (response.status === 204) {
        return true;
      } else {
        console.log("response status wasnt 204: ", response.status);
      }
    } catch (error) {
      throw error;
    }
  });
}
function fetchAlphaModels() {
  return __async$6(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(
        `${Config[stage].apiUrl}/portfolio-builder/alpha-models`,
        {
          method: "get",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: getAuthToken()
          }
        }
      );
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return JSON.parse(res.data);
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function fetchAssetMenu() {
  return __async$6(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(
        `${Config[stage].apiUrl}/portfolio-builder/asset-menu`,
        {
          method: "get",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: getAuthToken()
          }
        }
      );
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return JSON.parse(res.data);
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function fetchMyPortfolios() {
  return __async$6(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/portfolios`, {
        method: "get",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        }
      });
      if (response.status === 200) {
        if (response.body) {
          const res = yield response.json();
          return res.data;
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function fetchPortfolio(id) {
  return __async$6(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/portfolios/${id}`, {
        method: "get",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        }
      });
      if (response.status === 200) {
        if (response.body) {
          const res = yield response.json();
          return res.data;
        } else {
          const res = yield response.json();
          return JSON.parse(res.data);
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}

var __async$5 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getSignedUrl(params) {
  return __async$5(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(`${Config[stage].apiUrl}/sign-url`, {
        method: "post",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        },
        body: JSON.stringify(params)
      });
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return res.signedUrl;
        } else {
          const res = yield response.json();
          return res.signedUrl;
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}
function getCloudfrontSignedUrl(params) {
  return __async$5(this, null, function* () {
    const stage = getStage();
    try {
      const response = yield fetch(
        `${Config[stage].apiUrl}/sign-url/cloudfront`,
        {
          method: "post",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: getAuthToken()
          },
          body: JSON.stringify(params)
        }
      );
      if (response.status === 200) {
        if (response.body) {
          const { body } = response;
          const res = yield new Response(body, {}).json();
          return res.signedUrl;
        } else {
          const res = yield response.json();
          return res.signedUrl;
        }
      } else {
        const { error } = yield response.json();
        throw new Error(error.message);
      }
    } catch (error) {
      throw error;
    }
  });
}

var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchOurPicks = () => __async$4(void 0, null, function* () {
  try {
    const data = yield fetchReadings({
      jsonUrl: ReadingsFilename.picks
    });
    return data;
  } catch (error) {
    throw error;
  }
});
const fetchTrendRiskStocks = () => __async$4(void 0, null, function* () {
  try {
    const response = yield fetchReadings({
      jsonUrl: ReadingsFilename.trendRisk
    });
    const {
      data,
      as_of: date,
      risk: { current_value: currentValue, data: components }
    } = response;
    return {
      data,
      date,
      risk: {
        currentValue,
        components,
        date
      }
    };
  } catch (error) {
    throw error;
  }
});
const fetchFullCycleReadings = () => __async$4(void 0, null, function* () {
  var _a;
  try {
    const isDev = ((_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname) === "dev.3fourteenresearch.com";
    const jsonUrl = isDev ? ReadingsFilename.fullCycleDev : ReadingsFilename.fullCycle;
    const response = yield fetchReadings({
      jsonUrl
    });
    return response;
  } catch (error) {
    throw error;
  }
});
const fetchFctmReadings = () => __async$4(void 0, null, function* () {
  try {
    const response = yield fetchReadings({
      jsonUrl: ReadingsFilename.fctm
    });
    return response;
  } catch (error) {
    throw error;
  }
});

var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const fetchStratAA = () => __async$3(void 0, null, function* () {
  try {
    const data = yield fetchReadings({
      jsonUrl: ReadingsFilename.stratAA
    });
    return data;
  } catch (error) {
    throw error;
  }
});

var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function cancelSubscription(id) {
  return __async$2(this, null, function* () {
    try {
      const stage = getStage();
      const response = yield fetch(
        `${Config[stage].apiUrl}/subscriptions/${id}/cancel`,
        {
          method: "post",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: getAuthToken()
          }
        }
      );
      const { data, error } = yield response.json();
      if (!!error) {
        throw new Error(error.message);
      }
      return data;
    } catch (e) {
      throw e;
    }
  });
}
function resumeSubscription(id) {
  return __async$2(this, null, function* () {
    try {
      const stage = getStage();
      const response = yield fetch(
        `${Config[stage].apiUrl}/subscriptions/${id}/resume`,
        {
          method: "post",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: getAuthToken()
          }
        }
      );
      const { data, error } = yield response.json();
      if (!!error) {
        throw new Error(error.message);
      }
      return data;
    } catch (e) {
      throw e;
    }
  });
}

const UPDATE_USER = graphqlRequest.gql`
  mutation UpdateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $password: String
  ) {
    updateUser(
      input: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        email: $email
        password: $password
      }
    ) {
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
const SEND_PASSWORD_RESET_EMAIL = graphqlRequest.gql`
  mutation SendPasswordResetEmail($username: String!) {
    sendPasswordResetEmail(input: { username: $username }) {
      user {
        userId
        email
      }
    }
  }
`;

const GET_COMMENTARY = graphqlRequest.gql`
  query GetCommentary(
    $categories: [ID]
    $first: Int
    $startCursor: String
    $tags: [String!]
    $day: Int
    $month: Int
    $year: Int
    $search: String
    $authors: [ID]
    $name: String
    $categoryName: String
  ) {
    posts(
      first: $first
      after: $startCursor
      where: {
        categoryIn: $categories
        search: $search
        tagSlugIn: $tags
        dateQuery: { day: $day, month: $month, year: $year }
        authorIn: $authors
        name: $name
        categoryName: $categoryName
      }
    ) {
      pageInfo {
        startCursor
        hasNextPage
        endCursor
        hasPreviousPage
      }
      nodes {
        id
        filename
        title
        excerpt
        date
        slug
        author {
          node {
            name
            databaseId
          }
        }
        categories {
          nodes {
            categoryId
            slug
          }
        }
      }
    }
  }
`;
const GET_SORTED_COMMENTARY = graphqlRequest.gql`
  query GetSortedCommentary(
    $categories: [ID]
    $first: Int
    $startCursor: String
    $tags: [String!]
    $field: PostObjectsConnectionOrderbyEnum!
    $order: OrderEnum!
    $day: Int
    $month: Int
    $year: Int
    $search: String
    $authors: [ID]
    $name: String
    $categoryName: String
  ) {
    posts(
      first: $first
      after: $startCursor
      where: {
        categoryIn: $categories
        search: $search
        tagSlugIn: $tags
        orderby: { field: $field, order: $order }
        dateQuery: { day: $day, month: $month, year: $year }
        authorIn: $authors
        name: $name
        categoryName: $categoryName
      }
    ) {
      pageInfo {
        startCursor
        hasNextPage
        endCursor
        hasPreviousPage
      }
      nodes {
        id
        filename
        title
        excerpt
        date
        slug
        author {
          node {
            name
            databaseId
          }
        }
        categories {
          nodes {
            categoryId
            slug
          }
        }
      }
    }
  }
`;
const GET_CHARTS = graphqlRequest.gql`
  query GetCharts(
    $first: Int
    $tags: [String!]
    $field: PostObjectsConnectionOrderbyEnum!
    $order: OrderEnum!
    $search: String
    $name: String
    $startCursor: String
  ) {
    posts(
      first: $first
      after: $startCursor
      where: {
        categoryId: 18
        search: $search
        tagSlugIn: $tags
        orderby: { field: $field, order: $order }
        name: $name
        categoryName: "charts"
      }
    ) {
      pageInfo {
        startCursor
        hasNextPage
        endCursor
        hasPreviousPage
      }
      nodes {
        id
        filename
        title
        excerpt
        date
        slug
        isCustom
        dataUrl
        author {
          node {
            name
          }
        }
        categories {
          nodes {
            categoryId
            slug
          }
        }
      }
    }
  }
`;
const GET_POST_BY = graphqlRequest.gql`
  query GetPostBy($id: ID, $uri: String) {
    postBy(id: $id, uri: $uri) {
      id
      filename
      title
      excerpt
      date
      slug
      isCustom
      dataUrl
      content
      author {
        node {
          name
          databaseId
        }
      }
      categories {
        nodes {
          categoryId
          slug
        }
      }
    }
  }
`;
const SEARCH_POSTS = graphqlRequest.gql`
  query SearchPosts($search: String!, $categories: [ID]) {
    posts(where: { search: $search, categoryIn: $categories }, first: 200) {
      nodes {
        id
        filename
        title
        excerpt
        date
        slug
        content
        isCustom
        dataUrl
        author {
          node {
            name
            databaseId
          }
        }
        categories {
          nodes {
            categoryId
            slug
          }
        }
      }
    }
  }
`;

function flattenPost(post) {
  var _a, _b;
  const {
    id,
    title,
    excerpt,
    date,
    slug,
    filename,
    categories,
    author: authorInfo,
    isCustom,
    dataUrl,
    content
  } = post;
  const categorySlug = categories == null ? void 0 : categories.nodes[0].slug;
  const categoryId = categories == null ? void 0 : categories.nodes[0].categoryId;
  const author = (_a = authorInfo == null ? void 0 : authorInfo.node) == null ? void 0 : _a.name;
  const authorId = ((_b = authorInfo == null ? void 0 : authorInfo.node) == null ? void 0 : _b.databaseId) || null;
  return {
    id,
    title,
    excerpt,
    date,
    content,
    slug,
    author,
    authorId,
    categorySlug,
    categoryId,
    filename,
    isCustom: isCustom || false,
    dataUrl: dataUrl || ""
  };
}
function flattenPosts(data) {
  const updated = data.map((post) => {
    return flattenPost(post);
  });
  return updated;
}

function getAssetTableCellColor(current, previous) {
  if (current === null || previous === null) {
    return void 0;
  }
  if (current > previous) {
    return "increase";
  } else if (current < previous) {
    return "decrease";
  } else {
    return "noChange";
  }
}

function getDateProperties(date) {
  const isoDate = date.split("T")[0];
  const year = isoDate == null ? void 0 : isoDate.split("-")[0];
  return {
    isoDate,
    year
  };
}

function isValidEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function isValidPassword(password) {
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
  return !!password.match(passwordRegex);
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function fetchCommentary(variables) {
  return __async$1(this, null, function* () {
    const {
      categories = commentaryCategoryIds,
      first = 100,
      startCursor,
      tags = [],
      field,
      order,
      day,
      month,
      year,
      search,
      authors,
      slug,
      categorySlug
    } = variables || {};
    const base = {
      categories,
      first,
      startCursor,
      tags,
      field,
      order,
      day,
      month,
      year,
      search,
      authors,
      name: slug,
      categoryName: categorySlug
    };
    const shouldSort = !!field && !!order;
    const params = shouldSort ? __spreadProps(__spreadValues({}, base), { field, order }) : base;
    const query = shouldSort ? GET_SORTED_COMMENTARY : GET_COMMENTARY;
    try {
      const { posts } = yield graphRequest(query, params);
      const commentary = flattenPosts(posts.nodes);
      return {
        pageInfo: posts.pageInfo,
        data: commentary
      };
    } catch (e) {
      throw e;
    }
  });
}
function fetchCharts(variables) {
  return __async$1(this, null, function* () {
    const {
      first = 100,
      startCursor,
      tags = [],
      field = "DATE",
      order = "DESC",
      search,
      slug
    } = variables || {};
    try {
      const { posts } = yield graphRequest(GET_CHARTS, {
        first,
        startCursor,
        tags,
        field,
        order,
        search,
        name: slug
      });
      const charts = flattenPosts(posts.nodes);
      return {
        pageInfo: posts.pageInfo,
        data: charts
      };
    } catch (e) {
      throw e;
    }
  });
}
function fetchPostBy(variables) {
  return __async$1(this, null, function* () {
    const { id, uri } = variables || {};
    try {
      const { postBy } = yield graphRequest(GET_POST_BY, {
        id,
        uri
      });
      const post = flattenPost(postBy);
      return post;
    } catch (e) {
      throw e;
    }
  });
}
function fetchSearchResults(variables) {
  return __async$1(this, null, function* () {
    const { categories, search } = variables;
    const { posts } = yield graphRequest(SEARCH_POSTS, {
      categories,
      search
    });
    return flattenPosts(posts.nodes);
  });
}

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
function getMe() {
  return __async(this, null, function* () {
    try {
      const stage = getStage();
      const response = yield fetch(`${Config[stage].apiUrl}/user/me`, {
        method: "get",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
          Authorization: getAuthToken()
        }
      });
      const { data, error } = yield response.json();
      if (!!error) {
        throw error;
      }
      return data;
    } catch (e) {
      throw e;
    }
  });
}
const updateMe = (params) => __async(void 0, null, function* () {
  const stage = getStage();
  try {
    const response = yield fetch(`${Config[stage].apiUrl}/user/me`, {
      method: "post",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
        Authorization: getAuthToken()
      },
      body: JSON.stringify(params)
    });
    const { data, error } = yield response.json();
    if (!!error) {
      throw error;
    }
    return data.user;
  } catch (error) {
    throw error;
  }
});
const changePassword = (params) => __async(void 0, null, function* () {
  try {
    const {
      updateUser: { user }
    } = yield graphRequest(UPDATE_USER, {
      id: params.userId,
      password: params.password
    });
    return user;
  } catch (error) {
    throw error;
  }
});
const sendPasswordResetEmail = (email) => __async(void 0, null, function* () {
  try {
    yield graphRequest(SEND_PASSWORD_RESET_EMAIL, {
      username: email
    });
  } catch (error) {
    throw error;
  }
});

function useToggleBoolean(initialValue) {
  const [value, setValue] = react.useState(initialValue);
  const toggle = react.useCallback(() => {
    setValue(!value);
  }, [value]);
  const setTrue = react.useCallback(() => {
    !value && setValue(true);
  }, [value]);
  const setFalse = react.useCallback(() => {
    value && setValue(false);
  }, [value]);
  return [value, toggle, setTrue, setFalse];
}

exports.ANNUAL_MEMBERSHIP_ID = ANNUAL_MEMBERSHIP_ID;
exports.AllocationModelCode = AllocationModelCode;
exports.Config = Config;
exports.CoreModelCode = CoreModelCode;
exports.CoreModelSignal = CoreModelSignal;
exports.GET_CHARTS = GET_CHARTS;
exports.GET_COMMENTARY = GET_COMMENTARY;
exports.GET_POST_BY = GET_POST_BY;
exports.GET_SORTED_COMMENTARY = GET_SORTED_COMMENTARY;
exports.LoginErrorResponse = LoginErrorResponse;
exports.PORTFOLIO_BUILDER_ANNUAL_MEMBERSHIP_ID = PORTFOLIO_BUILDER_ANNUAL_MEMBERSHIP_ID;
exports.PORTFOLIO_BUILDER_MONTHLY_MEMBERSHIP_ID = PORTFOLIO_BUILDER_MONTHLY_MEMBERSHIP_ID;
exports.PUBLIC_CLOUDFRONT_DOMAIN = PUBLIC_CLOUDFRONT_DOMAIN;
exports.QUARTERLY_MEMBERSHIP_ID = QUARTERLY_MEMBERSHIP_ID;
exports.ReadingsFilename = ReadingsFilename;
exports.RecommendationWeight = RecommendationWeight;
exports.SEARCH_POSTS = SEARCH_POSTS;
exports.SEMIANNUAL_MEMBERSHIP_ID = SEMIANNUAL_MEMBERSHIP_ID;
exports.SEND_PASSWORD_RESET_EMAIL = SEND_PASSWORD_RESET_EMAIL;
exports.Stage = Stage;
exports.StockSelectionModelCode = StockSelectionModelCode;
exports.TRIAL_MEMBERSHIP_ID = TRIAL_MEMBERSHIP_ID;
exports.UPDATE_USER = UPDATE_USER;
exports.WeightColor = WeightColor;
exports.almostWhite = almostWhite;
exports.arylide = arylide;
exports.assetNameMap = assetNameMap;
exports.authorMap = authorMap;
exports.burntOrange = burntOrange;
exports.cadetBlue = cadetBlue;
exports.cambridgeBlue = cambridgeBlue;
exports.camel = camel;
exports.cancelSubscription = cancelSubscription;
exports.carrot = carrot;
exports.categorizedPostIds = categorizedPostIds;
exports.categorySlugMap = categorySlugMap;
exports.catwaba = catwaba;
exports.changePassword = changePassword;
exports.chartBookColor = chartBookColor;
exports.chartBooksCategoryId = chartBooksCategoryId;
exports.chartColor = chartColor;
exports.chartColors = chartColors;
exports.chartTagFilters = chartTagFilters;
exports.chartsCategoryId = chartsCategoryId;
exports.chartsSortOptions = chartsSortOptions;
exports.commentaryAuthorFilters = commentaryAuthorFilters;
exports.commentaryCategoryIds = commentaryCategoryIds;
exports.commentarySortOptions = commentarySortOptions;
exports.commentaryTypeFilters = commentaryTypeFilters;
exports.commentaryYearFilters = commentaryYearFilters;
exports.copperRed = copperRed;
exports.coreModelColorMap = coreModelColorMap;
exports.coreModelComponentMap = coreModelComponentMap;
exports.coreModelSignalMap = coreModelSignalMap;
exports.crudeModelId = crudeModelId;
exports.cyan = cyan;
exports.dandelion = dandelion;
exports.darkGray = darkGray;
exports.darkPurple = darkPurple;
exports.darkRed = darkRed;
exports.darkSienna = darkSienna;
exports.darkTeal = darkTeal;
exports.darkViolet = darkViolet;
exports.darkerTeal = darkerTeal;
exports.defaultGray = defaultGray;
exports.deleteAuthToken = deleteAuthToken;
exports.deletePortfolio = deletePortfolio;
exports.eggplant = eggplant;
exports.extraDarkGray = extraDarkGray;
exports.extraExtraLightGray = extraExtraLightGray;
exports.extraLightGray = extraLightGray;
exports.facebookBlue = facebookBlue;
exports.fernandoVidal = fernandoVidal;
exports.fetchAlphaModels = fetchAlphaModels;
exports.fetchAssetMenu = fetchAssetMenu;
exports.fetchBitcoinReadings = fetchBitcoinReadings;
exports.fetchCharts = fetchCharts;
exports.fetchCommentary = fetchCommentary;
exports.fetchCrudeReadings = fetchCrudeReadings;
exports.fetchDrawdownReadings = fetchDrawdownReadings;
exports.fetchFavorites = fetchFavorites;
exports.fetchFctmReadings = fetchFctmReadings;
exports.fetchFullCycleReadings = fetchFullCycleReadings;
exports.fetchGoldReadings = fetchGoldReadings;
exports.fetchLatestCommentary = fetchLatestCommentary;
exports.fetchMyPortfolios = fetchMyPortfolios;
exports.fetchOurPicks = fetchOurPicks;
exports.fetchPerformance = fetchPerformance;
exports.fetchPortfolio = fetchPortfolio;
exports.fetchPostBy = fetchPostBy;
exports.fetchRaaReadings = fetchRaaReadings;
exports.fetchReadings = fetchReadings;
exports.fetchSearchResults = fetchSearchResults;
exports.fetchSectorRotation = fetchSectorRotation;
exports.fetchStratAA = fetchStratAA;
exports.fetchTrendRiskStocks = fetchTrendRiskStocks;
exports.fetchYoReadings = fetchYoReadings;
exports.filterCommentary = filterCommentary;
exports.flattenPost = flattenPost;
exports.flattenPosts = flattenPosts;
exports.flattenYoReadings = flattenYoReadings;
exports.formatMarketCap = formatMarketCap;
exports.formatPercent = formatPercent;
exports.formatWeight = formatWeight;
exports.getAssetTableCellColor = getAssetTableCellColor;
exports.getAuthToken = getAuthToken;
exports.getCloudfrontSignedUrl = getCloudfrontSignedUrl;
exports.getCurrentDrawdownRisk = getCurrentDrawdownRisk;
exports.getDateProperties = getDateProperties;
exports.getGroupedSectors = getGroupedSectors;
exports.getImplicitCashPosition = getImplicitCashPosition;
exports.getIndustryCellColor = getIndustryCellColor;
exports.getMe = getMe;
exports.getRecReading = getRecReading;
exports.getRiskColor = getRiskColor;
exports.getSectorCellColor = getSectorCellColor;
exports.getSignedUrl = getSignedUrl;
exports.getStage = getStage;
exports.getWeightChange = getWeightChange;
exports.goldModelId = goldModelId;
exports.goldenRod = goldenRod;
exports.googleYellow = googleYellow;
exports.graphRequest = graphRequest;
exports.green = green;
exports.introductoryPaperLinks = introductoryPaperLinks;
exports.isValidEmail = isValidEmail;
exports.isValidPassword = isValidPassword;
exports.lightGray = lightGray;
exports.lightLavender = lightLavender;
exports.lightestTeal = lightestTeal;
exports.linkedin = linkedin;
exports.login = login;
exports.logout = logout;
exports.macMinimize = macMinimize;
exports.midRed = midRed;
exports.middleGray = middleGray;
exports.middleViolet = middleViolet;
exports.mint = mint;
exports.modelColor = modelColor;
exports.modelUpdateColor = modelUpdateColor;
exports.modelUpdatesCategoryId = modelUpdatesCategoryId;
exports.modelsCategoryId = modelsCategoryId;
exports.mossGreen = mossGreen;
exports.mustard = mustard;
exports.muteGray = muteGray;
exports.muteGreen = muteGreen;
exports.muteNavy = muteNavy;
exports.muteOrange = muteOrange;
exports.muteTurqoise = muteTurqoise;
exports.muteYellow = muteYellow;
exports.navy = navy;
exports.orange = orange;
exports.orangeSoda = orangeSoda;
exports.plum = plum;
exports.positionUpdateColor = positionUpdateColor;
exports.positionUpdatesCategoryId = positionUpdatesCategoryId;
exports.publicationColor = publicationColor;
exports.publicationsCategoryId = publicationsCategoryId;
exports.puke = puke;
exports.purple = purple;
exports.queenBlue = queenBlue;
exports.raaVersions = raaVersions;
exports.readingsFilenameMap = readingsFilenameMap;
exports.realAssetAllocationModelId = realAssetAllocationModelId;
exports.recommendationMap = recommendationMap;
exports.red = red;
exports.refreshToken = refreshToken;
exports.resumeSubscription = resumeSubscription;
exports.retroColor = retroColor;
exports.retrospectiveCategoryId = retrospectiveCategoryId;
exports.royalPurple = royalPurple;
exports.rusticOrange = rusticOrange;
exports.sectorDisplayNameMap = sectorDisplayNameMap;
exports.sendPasswordResetEmail = sendPasswordResetEmail;
exports.setStage = setStage;
exports.shamrock = shamrock;
exports.socialBlue = socialBlue;
exports.sortAssets = sortAssets;
exports.tagLabelMap = tagLabelMap;
exports.tangerine = tangerine;
exports.tealBlack = tealBlack;
exports.terraCotta = terraCotta;
exports.toggleFavorite = toggleFavorite;
exports.tuscanRed = tuscanRed;
exports.twitter = twitter;
exports.updateFavorites = updateFavorites;
exports.updateMe = updateMe;
exports.useToggleBoolean = useToggleBoolean;
exports.vermillion = vermillion;
exports.warrenPies = warrenPies;
exports.weightGreen = weightGreen;
exports.weightRed = weightRed;
exports.weightYellow = weightYellow;
exports.white = white;
exports.yoModelId = yoModelId;
//# sourceMappingURL=index.js.map
